import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { Link } from 'react-router-dom';
import useRoles from '../../hooks/useRoles';

const MaterialList = () => {
  const { hasRole } = useRoles();
  const [materials, setMaterials] = useState([]);

  useEffect(() => {
    const fetchMaterials = async () => {
      try {
        const res = await api.get('/materials');
        setMaterials(res.data);
      } catch (err) {
        console.error(err);
      }
    };
    fetchMaterials();
  }, []);

  const handleDelete = async (id) => {
    try {
      await api.delete(`/materials/${id}`);
      setMaterials(materials.filter((material) => material.id !== id));
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="container mt-4">
      <h1>Материалы</h1>
      {hasRole('CreateCategory') && (
        <Link to="/materials/new" className="btn btn-primary mb-3">
          Добавить новый материал
        </Link>
      )}
      
      <table className="table table-striped">
        <thead>
          <tr>
            <th>Название</th>
            <th>Действие</th>
          </tr>
        </thead>
        <tbody>
          {materials.map((material) => (
            <tr key={material.id}>
              <td>{material.name}</td>
              <td>
                {hasRole('CreateCategory') && (
                  <Link
                  to={`/materials/${material.id}/edit`}
                  className="btn btn-sm btn-warning me-2"
                  >
                    Редактировать
                  </Link>
                )}
                
                {hasRole('CreateCategory') && (
                  <button
                  className="btn btn-sm btn-danger"
                  onClick={() => handleDelete(material.id)}
                  >
                    Удалить
                  </button>
                )}
                
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default MaterialList;